import React from "react";

export default function Header() {
  return (
    <header className="header">
      <h1>Dice Game</h1>
    </header>
  );
}
